export default __webpack_public_path__ + "static/media/cif-sc.02391836.svg";